import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export type UseUnarchiveJobLevelsParams = {
    readonly jobArchitectureId: string;
    readonly jobLevelIds: NonEmptyArray<string>;
};

export type UseUnarchiveJobLevelsResult = UseMutationResult<unknown, Error, UseUnarchiveJobLevelsParams>;

export const useUnarchiveJobLevels = (): UseUnarchiveJobLevelsResult => {
    const { unarchiveJobLevels } = useApplicationFetchers();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ jobArchitectureId, jobLevelIds }: UseUnarchiveJobLevelsParams) => {
            const result = await unarchiveJobLevels({
                jobArchitectureId,
                jobLevelIds,
            });

            if (result.isErr) {
                throw result.error;
            }

            return result.value;
        },
        onSuccess: (_, { jobArchitectureId }) => {
            queryClient.invalidateQueries({
                queryKey: jobArchitectureKeys.architecture(jobArchitectureId),
            });
            queryClient.invalidateQueries({
                queryKey: jobArchitectureKeys.architectureDetail(jobArchitectureId),
            });
        },
        throwOnError: false,
    });
};
